import React from "react";
import AdminGeneralSettingsPage from "./AdminGeneralSettingsPage";

const AdminKvkk = () => <AdminGeneralSettingsPage field="kvkk" title="KVKK" />;

export default AdminKvkk;
